// extracted by mini-css-extract-plugin
export default {"container":"_I-z","error":"aJ-z","disabled":"bJ-z","submit":"cJ-z","option":"dJ-z","success":"eJ-z","failure":"fJ-z"};